(() => {
  "use strict";
  if (window.CartPurchase || !window.IllegalCartCoordinator) return;
  const strings = window.IllegalShirts.purchase_strings;
  const { Coordinator, identity } = window.IllegalCartCoordinator;
  const message = (error) => strings[error?.code] || strings.error;
  const fail = (code) => {
    throw Object.assign(new Error(strings[code]), { code });
  };
  let renderedRevision = -1;
  let resuming = null;
  let submitted = false;
  let handoffTimer;
  let controller;
  let uiReady = false;
  const optionIntents = new WeakMap();
  function rememberOption(event) {
    const input = event.target;
    if (
      !event.isTrusted ||
      !input.matches?.(
        'input[name^="properties["],select[name^="properties["],textarea[name^="properties["]',
      ) ||
      input.type === "hidden" ||
      input.type === "file" ||
      input.disabled
    )
      return;
    const form = input.form;
    if (!form?.matches("[data-product-form]")) return;
    if ((input.type === "radio" || input.type === "checkbox") && !input.checked)
      return;
    const intents = optionIntents.get(form) || new Map();
    intents.set(input.name, input.value);
    optionIntents.set(form, intents);
  }
  function pageRows(cart) {
    const root = document.getElementById("cart-line-items");
    if (!root) return;
    root.innerHTML = cart.items
      .map(
        (item) => `
      <div class="cart-line-item" data-key="${escapeHtml(item.key)}" data-variant-id="${item.variant_id}">
        <div class="cart-line-item-inner">
          <a href="${escapeHtml(item.url)}" class="cart-line-img-wrap">${item.image ? `<img src="${escapeHtml(sizedImageUrl(item.image, 240))}" alt="${escapeHtml(item.product_title)}" width="240" height="300" loading="lazy">` : ""}</a>
          <div class="cart-line-details"><a class="cart-line-title" href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>
            <div class="cart-line-variant">${escapeHtml(item.variant_title || "")}</div>${renderLineItemProperties(item.properties)}
            ${item.selling_plan_allocation ? `<p>${escapeHtml(item.selling_plan_allocation.selling_plan.name)}</p>` : ""}
            <div class="cart-line-unit-price">${formatMoney(item.final_price)}</div>
          </div>
          <div class="cart-line-qty"><div class="cart-line-stepper">
            <button type="button" class="cart-qty-btn" data-action="decrease" data-key="${escapeHtml(item.key)}" aria-label="Decrease quantity">−</button>
            <input type="number" name="updates[]" min="0" step="1" class="cart-qty-input" data-key="${escapeHtml(item.key)}" value="${item.quantity}" aria-label="Quantity for ${escapeHtml(item.product_title)}">
            <button type="button" class="cart-qty-btn" data-action="increase" data-key="${escapeHtml(item.key)}" aria-label="Increase quantity">+</button>
          </div></div>
          <div class="cart-line-price">${formatMoney(item.final_line_price)}</div>
          <button type="button" class="cart-line-remove" data-key="${escapeHtml(item.key)}" aria-label="Remove ${escapeHtml(item.product_title)}">${escapeHtml(strings.remove)}</button>
        </div>
      </div>`,
      )
      .join("");
    if (!cart.item_count) root.textContent = strings.empty;
    CartPage.updateSummary(cart);
    CartPage.updateProgressBar(cart);
    CartPage.updateCounts(cart);
    CartPage.syncMinusButtons();
  }
  function focusSnapshot() {
    const el = document.activeElement;
    const row = el?.closest("[data-key]");
    if (!row) return null;
    return {
      signature: controller.aliases.get(row.dataset.key),
      selector: el.matches("input")
        ? "input"
        : el.getAttribute("aria-label")?.startsWith("Decrease")
          ? 'button[aria-label^="Decrease"]'
          : el.getAttribute("aria-label")?.startsWith("Increase")
            ? 'button[aria-label^="Increase"]'
            : ".cart-line-remove",
      page: !!el.closest("#cart-page"),
    };
  }
  function update(state) {
    if (!uiReady) return;
    if (state.revision !== renderedRevision) {
      const focused = focusSnapshot();
      renderedRevision = state.revision;
      IllegalCart.render(state.cart);
      pageRows(state.cart);
      if (focused) {
        const item = state.cart.items.find(
          (i) => identity(i) === focused.signature,
        );
        const scope = document.getElementById(
          focused.page ? "cart-page" : "cart-drawer",
        );
        const row =
          item &&
          [...(scope?.querySelectorAll("[data-key]") || [])].find(
            (e) =>
              e.dataset.key === item.key && e.querySelector(focused.selector),
          );
        (
          row?.querySelector(focused.selector) ||
          scope?.querySelector('[name="checkout"]') ||
          scope?.querySelector(".cart-close")
        )?.focus({ preventScroll: true });
      }
    }
    document
      .querySelectorAll("[data-drawer-quantity],#cart-page .cart-qty-input")
      .forEach((input) => {
        const desired = controller.desired(input.dataset.key);
        if (document.activeElement !== input || input.value !== "")
          input.value = desired;
      });
    document.querySelectorAll("[data-cart-status]").forEach((el) => {
      el.textContent =
        state.locked || state.pending
          ? strings.updating
          : state.error
            ? ""
            : strings.ready;
    });
    document.querySelectorAll("[data-cart-recovery]").forEach((el) => {
      el.hidden = !state.error;
      el.querySelector("[data-cart-error]").textContent = state.error
        ? message(state.error)
        : "";
    });
    document
      .querySelectorAll(
        '[data-cart-checkout] [name="checkout"],.cart-mobile-checkout-btn',
      )
      .forEach((button) => {
        button.disabled = !state.cart.item_count && !state.pending;
        button.setAttribute(
          "aria-disabled",
          String(state.locked || button.disabled),
        );
        button.setAttribute("aria-busy", String(state.locked));
      });
    document
      .querySelectorAll(
        "#cart-drawer .cart-line-controls button,[data-drawer-quantity],#cart-page .cart-qty-btn,#cart-page .cart-qty-input,#cart-page .cart-line-remove,#add-to-cart-btn,#pdp-sticky-add,#pdp-mobile-add,#quick-add-submit",
      )
      .forEach((el) => {
        if (state.locked) {
          if (!el.hasAttribute("data-cart-was-disabled"))
            el.dataset.cartWasDisabled = String(el.disabled);
          el.disabled = true;
        } else if (!state.locked && el.hasAttribute("data-cart-was-disabled")) {
          el.disabled = el.dataset.cartWasDisabled === "true";
          delete el.dataset.cartWasDisabled;
        }
      });
  }
  function addFromForm(form) {
    if (!form || !form.reportValidity())
      return Promise.reject(
        Object.assign(new Error(strings.app_required), {
          code: "app_required",
        }),
      );
    const scope = form.closest(".shopify-section") || form;
    for (const input of scope.querySelectorAll(
      '[name^="properties["][required]',
    ))
      if (!input.disabled && !input.checkValidity()) {
        input.reportValidity();
        return Promise.reject(
          Object.assign(new Error(strings.app_required), {
            code: "app_required",
          }),
        );
      }
    const kind = form.dataset.purchaseKind;
    for (const [name, intended] of optionIntents.get(form) || []) {
      const controls = [...form.elements].filter(
        (input) =>
          input.name === name &&
          input.type !== "hidden" &&
          !input.disabled &&
          !(
            (input.type === "radio" || input.type === "checkbox") &&
            !input.checked
          ),
      );
      if (
        controls.length &&
        !controls.some((input) => input.value === intended)
      )
        fail("options_changed");
    }
    if (
      kind === "custom" &&
      !form.querySelector('[name="properties[_cl_options]"]')
    )
      fail("options_loading");
    if (
      kind === "bundle" &&
      !form.querySelector('[name="properties[_bundle_selection]"]')
    )
      fail("options_loading");
    // Simple Bundles mirrors visible selections into hidden fields and its
    // component reference. Do not submit while its selection update is pending.
    if (kind === "bundle")
      for (const select of form.querySelectorAll(
        'select[name^="properties["]',
      )) {
        const mirrors = [
          ...form.querySelectorAll('input[type="hidden"]'),
        ].filter((input) => input.name === select.name);
        if (mirrors.some((input) => input.value !== select.value))
          fail("options_loading");
      }
    const data = new FormData(form);
    for (const input of scope.querySelectorAll('[name^="properties["]')) {
      if (
        input.disabled ||
        ((input.type === "checkbox" || input.type === "radio") &&
          !input.checked)
      )
        continue;
      if (input.form === form || form.contains(input)) continue;
      if (input.type === "file") {
        for (const file of input.files || []) data.append(input.name, file);
      } else data.append(input.name, input.value);
    }
    form
      .querySelectorAll('select[name^="properties["]')
      .forEach((select) => data.set(select.name, select.value));
    const item = {
      id: Number(data.get("id")),
      quantity: Number(data.get("quantity") || 1),
      properties: {},
      selling_plan: data.get("selling_plan") || "",
    };
    for (const [name, value] of data) {
      const match = name.match(/^properties\[(.*)\]$/);
      if (!match) continue;
      if (typeof value !== "string") {
        if (value.size) fail("options_loading");
        continue;
      }
      item.properties[match[1]] = value;
    }
    if (!item.id || !Number.isSafeInteger(item.quantity) || item.quantity < 1)
      fail("app_required");
    if (
      kind === "custom" &&
      !Object.entries(item.properties).some(
        ([k, v]) => !k.startsWith("_") && v.trim(),
      )
    )
      fail("custom_required");
    if (
      kind === "custom" &&
      [...form.querySelectorAll(".cl-po--preview-progress")].some(
        (el) => getComputedStyle(el).display !== "none" && el.value < el.max,
      )
    )
      fail("options_loading");
    return controller.add(data, [item], form);
  }
  function flushInputs(form) {
    document
      .querySelectorAll("[data-drawer-quantity],#cart-page .cart-qty-input")
      .forEach((input) => {
        const quantity = Number(input.value);
        if (
          input.value === "" ||
          !Number.isSafeInteger(quantity) ||
          quantity < 0
        )
          fail("quantity");
        if (quantity !== controller.desired(input.dataset.key))
          controller.change(input.dataset.key, quantity, 0);
      });
  }
  function submit(event) {
    const form = event.target.closest("[data-cart-checkout]");
    if (!form || (event.submitter?.name && event.submitter.name !== "checkout"))
      return;
    if (resuming === form && !submitted) {
      resuming = null;
      submitted = true;
      return;
    }
    event.preventDefault();
    if (submitted || controller.locked) return;
    const button =
      event.submitter?.name === "checkout"
        ? event.submitter
        : form.querySelector('[name="checkout"]');
    try {
      flushInputs(form);
    } catch (error) {
      controller.error = error;
      controller.emit();
      return;
    }
    controller
      .checkout(() => {
        form.querySelectorAll('[name="updates[]"]').forEach((input) => {
          input.disabled = true;
          input.dataset.cartHandoff = "";
        });
        resuming = form;
        button.disabled = false;
        form.requestSubmit(button);
        handoffTimer = setTimeout(() => {
          if (!submitted) return;
          restore();
          controller.error = Object.assign(new Error(strings.timeout), {
            code: "timeout",
          });
          controller.emit();
        }, 12000);
      })
      .catch(() => {});
  }
  function restore() {
    clearTimeout(handoffTimer);
    resuming = null;
    submitted = false;
    document.querySelectorAll("[data-cart-handoff]").forEach((input) => {
      input.disabled = false;
      delete input.dataset.cartHandoff;
    });
    controller.restore().catch(() => {});
    if (typeof PDP !== "undefined" && PDP.product) {
      PDP._adding = false;
      PDP.updateCtaState();
    }
    if (typeof QuickAdd !== "undefined") QuickAdd._adding = false;
  }
  try {
    controller = new Coordinator({
      fetch: window.fetch.bind(window),
      routes: window.IllegalShirts.routes,
      cart: JSON.parse(
        document.getElementById("cart-rewards-seed").textContent,
      ),
      onChange: update,
    });
  } catch (_) {
    return;
  }
  window.CartPurchase = { controller, message, addFromForm };
  document.documentElement.classList.add("cart-purchase-ready");
  document.addEventListener("submit", submit, true);
  document.addEventListener("input", rememberOption, true);
  document.addEventListener("change", rememberOption, true);
  document.addEventListener("input", (event) => {
    const input = event.target.closest(
      "[data-drawer-quantity],#cart-page .cart-qty-input",
    );
    if (!input || input.value === "") return;
    controller.change(input.dataset.key, Number(input.value));
  });
  document.addEventListener("click", (event) => {
    const retry = event.target.closest("[data-cart-retry]");
    if (retry)
      controller
        .retry()
        .then(() => {
          if (retry.closest("#pdp-add-error")) {
            PDP.clearAddError();
            if (controller.cart.item_count) IllegalCart.open();
          }
        })
        .catch(() => {});
  });
  window.addEventListener("pageshow", (event) => {
    if (event.persisted) restore();
  });
  document.addEventListener("shopify:section:load", () => {
    renderedRevision = -1;
    controller.emit();
  });
  const start = () => {
    uiReady = true;
    controller.emit();
    if (controller.cart.item_count) controller.refresh().catch(() => {});
  };
  if (document.readyState === "complete") start();
  else document.addEventListener("DOMContentLoaded", start, { once: true });
})();
